import { z } from "zod";
import { jobStatusSchema, masterItemChangeSchema, variableChangeSchema } from "./jobs.js";

export const singleAppDraftInputSchema = z.object({
  variableChanges: z.array(variableChangeSchema).default([]),
  masterItemChanges: z.array(masterItemChangeSchema).default([]),
});

export type SingleAppDraftInput = z.infer<typeof singleAppDraftInputSchema>;

export const singleAppDraftSummarySchema = z.object({
  totalPendingCount: z.number(),
  variablePendingCount: z.number(),
  masterItemPendingCount: z.number(),
  conflictCount: z.number().default(0),
});

export type SingleAppDraftSummary = z.infer<typeof singleAppDraftSummarySchema>;

export const singleAppDraftSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string(),
  userId: z.string(),
  connectionId: z.string().uuid(),
  appId: z.string(),
  variableChanges: z.array(variableChangeSchema),
  masterItemChanges: z.array(masterItemChangeSchema),
  activeJobId: z.string().uuid().nullable(),
  activeJobStatus: jobStatusSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  summary: singleAppDraftSummarySchema,
});

export type SingleAppDraft = z.infer<typeof singleAppDraftSchema>;

export const singleAppDraftResponseSchema = z.object({
  data: singleAppDraftSchema.nullable(),
});

export type SingleAppDraftResponse = z.infer<typeof singleAppDraftResponseSchema>;

export const syncSingleAppDraftResponseSchema = z.object({
  data: z.object({
    jobId: z.string().uuid(),
  }),
});

export type SyncSingleAppDraftResponse = z.infer<typeof syncSingleAppDraftResponseSchema>;
